import React from 'react';
import useSetting from '@src/hooks/useSetting';
import {
	breakpointXs,
	breakpointSm,
	breakpointMd,
	breakpointLg,
	breakpointXl,
} from '@src/styles/1__settings/_vars.module.scss';

const Picture = ({ alt, xsmall, small, medium, large, xlarge, defaultImage, onPictureLoad, loadLazy = true }) => {
	const breakpoints = {
		xsmall: `(max-width: ${breakpointXs})`,
		small: `(max-width: ${breakpointSm})`,
		medium: `(max-width: ${breakpointMd})`,
		large: `(max-width: ${breakpointLg})`,
		xlarge: `(max-width: ${breakpointXl})`,
	};
	const getSetting = useSetting();
	const cdnHost = getSetting('CDNHost', '');
	const loading = loadLazy ? 'lazy' : '';

	return (
		<picture onLoad={() => onPictureLoad && onPictureLoad()}>
			{xsmall && <source srcSet={`${cdnHost}${xsmall}`} media={breakpoints.xsmall} />}
			{small && <source srcSet={`${cdnHost}${small}`} media={breakpoints.small} />}
			{medium && <source srcSet={`${cdnHost}${medium}`} media={breakpoints.medium} />}
			{large && <source srcSet={`${cdnHost}${large}`} media={breakpoints.large} />}
			{xlarge && <source srcSet={`${cdnHost}${xlarge}`} media={breakpoints.xlarge} />}

			{defaultImage && <img src={`${cdnHost}${defaultImage}`} alt={alt} loading={loading} />}
		</picture>
	);
};

export default Picture;
